<template>
	<div id="password" class="form-container">
		<template v-if="has_password">
			<h2>{{$t('password.ChangePassword')}}</h2>
			<div class="form-item">
				<label for="">{{$t("password.CurrentPassword")}}</label>
				<input type="password" v-model="currentPassword"  @focus="validated = false" :class="(validated && !currentPassword) ? 'error' : ''" :placeholder="$t('password.CurrentPasswordTip')">
			</div>
			<div class="form-item">
				<label for="">{{$t("password.NewPassword")}}</label>
				<input type="password" v-model="newPassword" :placeholder="$t('password.NewPasswordTip')"  @focus="validated = false" :class="(validated && !newPassword) ? 'error' : ''">
			</div>
			<div class="form-item">
				<label for="">{{$t("password.ConfirmPassword")}}</label>
				<input type="password" v-model="confirmPassword" :placeholder="$t('password.ConfirmPasswordTip')"  @focus="validated = false" :class="(validated && !confirmPassword) ? 'error' : ''">
			</div>
			<div class="form-item">
				<label for=""></label>
				<wd-button type="danger" @click.native="submit" size="large" :styles="{width:'300px'}">{{$t("default.submit")}}</wd-button>
			</div>
		</template>
		<template v-else>
			<h2>{{$t('password.SetPassword')}}</h2>
			<div class="form-item">
				<label for="">{{$t("password.NewPassword")}}</label>
				<input type="password" v-model="newPassword" :placeholder="$t('password.NewPasswordTip')"  @focus="validated = false" :class="(validated && !newPassword) ? 'error' : ''">
			</div>
			<div class="form-item">
				<label for="">{{$t("password.ConfirmPassword")}}</label>
				<input type="password" v-model="confirmPassword" :placeholder="$t('password.ConfirmPasswordTip')"  @focus="validated = false" :class="(validated && !confirmPassword) ? 'error' : ''">
			</div>
			<div class="form-item">
				<label for=""></label>
				<wd-button type="danger" @click.native="passwordSubmit" size="large" :styles="{width:'300px'}">{{$t("default.submit")}}</wd-button>
			</div>
		</template>
	</div>
</template>
<script>
	import WdButton from '@/components/WdButton.vue';
	export default{
		name:"password",
		data(){
			return {
				currentPassword:"",
				newPassword:"",
				confirmPassword:"",
				has_password:true,
				validated:false
			}
		},
		components:{
			'wd-button':WdButton
		},
		computed:{
			 passwordRex(){
			   let patrn = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/;
			   if(!patrn.test(this.newPassword)) return false;
			   return true;
		   }
		},
		
		methods:{
			async submit(){
				this.validated = true;
				if(!this.currentPassword){
					this.$alert(this.$t("password.CurrentPasswordTip"))
					return;
				}
				if(!this.newPassword){
					this.$alert(this.$t("password.NewPasswordTip"))
					return;
				}
				if(!this.passwordRex){
					this.$alert(this.$t("login.PasswordErr"))
					return;
				}
				if(!this.confirmPassword){
					this.$alert(this.$t("password.ConfirmPasswordTip"))
					return;
				}
				if(this.newPassword == this.currentPassword){
					this.$alert(this.$t('password.NewPasswordSameAsOldPassword'))
					return;
				}
				if(this.newPassword != this.confirmPassword){
					this.$alert(this.$t('password.PasswordsNotMatch'))
					return;
				}

				let postData = {
					new_password:this.newPassword,
					old_password:this.currentPassword,
					confirm_password:this.confirmPassword
				};
				let data = await this.$api.post('/web/index/modifyPassword',postData);
				if(data.code == 0){
					this.$result(this.$t('password.PasswordChangeSuccess'));
					this.$api.setAuthToken('');
					this.$setUser(null);
				}else if(data.code == 420002){
					this.$alert(this.$t('password.OldPasswordError'));
				}else{
					this.$alert(data.msg)
				}
			},
			async passwordSubmit(){
				
				if(this.requesting) return;
				if(!this.newPassword){
					this.$alert(this.$t("password.NewPasswordTip"))
					return;
				}
				if(!this.passwordRex){
					this.$alert(this.$t("login.PasswordErr"))
					return;
				}
				if(!this.confirmPassword){
					this.$alert(this.$t("password.ConfirmPasswordTip"))
					return;
				}
				if(this.newPassword != this.confirmPassword){
					this.$alert(this.$t('password.PasswordsNotMatch'))
					return;
				}
				this.requesting = true;
				let postData = {
					new_password:this.newPassword,
					confirm_password:this.confirmPassword
				};
				let data = await this.$api.post('/web/index/modifyPassword',postData);
				if(data.code == 0){
					this.$result(this.$t('password.PasswordChangeSuccess'));
					this.has_password = true;
				}else{
					this.$alert(data.msg)
				}
				this.requesting = false;
			},
		},
		async created(){
			let user = await this.$getUser();
			if(user && user.password_level>=1){
				this.has_password = true;
			}
		}	
	}
</script>
<style scoped>
	.form-container{
		margin-top: 50px;
	}
</style>
